var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 3C0.25 1.48122 1.48122 0.25 3 0.25H10.9868C11.5506 0.25 12.0798 0.521573 12.4085 0.979549L15.4217 5.17745C15.6352 5.47488 15.75 5.83178 15.75 6.1979V17C15.75 18.5188 14.5188 19.75 13 19.75H3C1.48122 19.75 0.25 18.5188 0.25 17V3ZM3 1.75C2.30964 1.75 1.75 2.30964 1.75 3V17C1.75 17.6904 2.30964 18.25 3 18.25H13C13.6904 18.25 14.25 17.6904 14.25 17V6.89705H11C10.5858 6.89705 10.25 6.56126 10.25 6.14705V1.75H3Z",
    fill: "#209cee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0857 11.2185C10.8269 11.542 10.355 11.5944 10.0315 11.3357L8.75006 10.3105V13.75C8.75006 14.1642 8.41427 14.5 8.00006 14.5C7.58584 14.5 7.25006 14.1642 7.25006 13.75V10.3104L5.96855 11.3357C5.6451 11.5944 5.17313 11.542 4.91438 11.2185C4.65562 10.8951 4.70806 10.4231 5.03151 10.1643L7.52884 8.16648C7.65609 8.06359 7.81768 8.00148 7.99373 8.00003C7.99584 8.00001 7.99794 8 8.00006 8L8.00248 8C8.18159 8.00057 8.34591 8.06392 8.4746 8.16919L10.9685 10.1643C11.292 10.4231 11.3444 10.8951 11.0857 11.2185Z",
    fill: "#209cee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.eeaee326b9e86825db6bbd2dd2cb0221.svg";
export { ForwardRef as ReactComponent };